import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Avatar,
    Chip,
    Stack,
    Grid,
    Card,
    CardContent
} from '@mui/material';
import { EmojiEvents, TrendingUp, Star } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

const RewardsHeader = ({ user, userStats }) => {
    if (!user || !userStats) return null;

    const { currentLevel } = userStats;

    return (
        <Paper elevation={12} sx={{
            borderRadius: 4,
            overflow: 'hidden',
            mb: 4,
            background: `linear-gradient(135deg, ${currentLevel?.color || '#43a047'}15, ${currentLevel?.color || '#43a047'}25)`,
            border: `3px solid ${alpha(currentLevel?.color || '#43a047', 0.3)}`
        }}>
            <Box sx={{
                background: `linear-gradient(135deg, ${currentLevel?.color || '#43a047'}, ${alpha(currentLevel?.color || '#43a047', 0.8)})`,
                color: 'white',
                p: 4
            }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={8}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Avatar
                                src={user.profilePhotoPath}
                                sx={{
                                    width: 100,
                                    height: 100,
                                    border: '4px solid rgba(255,255,255,0.9)',
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
                                }}
                            >
                                {user.displayName?.charAt(0)}
                            </Avatar>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="h3" fontWeight={800} sx={{ mb: 1 }}>
                                    {user.displayName}
                                </Typography>
                                <Typography variant="h6" sx={{ opacity: 0.9, mb: 2 }}>
                                    🌟 Your Environmental Journey Dashboard
                                </Typography>
                                <Stack direction="row" spacing={1} flexWrap="wrap">
                                    <Chip
                                        icon={<span style={{ fontSize: '1.2rem' }}>{currentLevel?.icon}</span>}
                                        label={`${currentLevel?.name || 'Rookie'} Level`}
                                        sx={{
                                            background: 'rgba(255,255,255,0.2)',
                                            color: 'white',
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                            border: '2px solid rgba(255,255,255,0.3)'
                                        }}
                                    />
                                    <Chip
                                        icon={<Star />}
                                        label={`${userStats.totalPoints} Eco Points`}
                                        sx={{
                                            background: 'rgba(255,255,255,0.2)',
                                            color: 'white',
                                            fontWeight: 700,
                                            border: '2px solid rgba(255,255,255,0.3)'
                                        }}
                                    />
                                </Stack>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Box sx={{ textAlign: 'right' }}>
                            <Stack spacing={2}>
                                <Card sx={{
                                    background: 'rgba(255,255,255,0.15)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(255,255,255,0.2)'
                                }}>
                                    <CardContent sx={{ p: 2, textAlign: 'center' }}>
                                        <EmojiEvents sx={{ fontSize: 32, color: '#ffc400', mb: 1 }} />
                                        <Typography variant="h4" fontWeight={800} sx={{ color: 'white' }}>
                                            {userStats.totalBadges}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                                            Eco Badges Earned
                                        </Typography>
                                    </CardContent>
                                </Card>
                                {userStats.globalRank > 0 && (
                                    <Chip
                                        icon={<TrendingUp />}
                                        label={`Global Rank #${userStats.globalRank}`}
                                        sx={{
                                            background: 'linear-gradient(135deg, #ffc400, #ff8f00)',
                                            color: 'white',
                                            fontWeight: 700
                                        }}
                                    />
                                )}
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default RewardsHeader;
